import React, { useState, useEffect, useMemo } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { TextField, MenuItem } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import _ from "lodash";
import ApiPromoCategory from "../../../core/api/api.promocategory";
import SwalMessage from "../_Components/SwalMessage";
import { useNavigate } from "react-router-dom";
import SelectComponent from "../_Components/ReactSelectComponent";

export const NewpromoCategoryModal = ({
  showModalPromoCategory,
  setShowModalPromoCategory,
  selectedItem,
  setSelectedOffer,
  loading
}) => {
  let navigate = useNavigate();
  const defaultValues = useMemo(() => {
    if (selectedItem) return { name: selectedItem.name, promoCategoryType: { value: selectedItem.promoCategoryType, label: selectedItem.promoCategoryTypeS }, isActive: selectedItem.isActive }
    return {}
  }, [selectedItem])
  const [typeList, setTypeList] = useState([]);
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues });

  useEffect(() => {
    (async () => {
      try {
        const response = await ApiPromoCategory.getPromoCategoryType();
        if (response.succeeded) setTypeList(response.data);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);
  const handleClose = () => {
    setShowModalPromoCategory(false);
    setSelectedOffer(null)
  };
  const onSubmit = async (data) => {
    if (data.promoCategoryType) data.promoCategoryType = data.promoCategoryType.value
    try {
      const sendData = { ...data }
      if (selectedItem) sendData.id = selectedItem.id
      let response = await ApiPromoCategory.addOrEditPromoCategory(sendData);

      if (!response.succeeded) {
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
        return
      }
      if (response.succeeded && !selectedItem) {
        navigate("/CreateEditAmusementServicePromoCategory/" + response.data);
      }
      setShowModalPromoCategory(false);
      setSelectedOffer(null)
      // document.getElementById("submitButton").click();
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      <Modal centered size="md" show={showModalPromoCategory} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>{selectedItem ? "ویرایش گروه تخفیف" : "ایجاد گروه تخفیف"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label=" نام گروه تخفیفی "
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onInput={onChange}
                  />
                )}
              />
              {errors.name && <span className="text-danger">** لطفا نام گروه را وارد نمایید</span>}
            </Col>
            <Col xs="12">
              <Controller
                name="promoCategoryType"
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                  <SelectComponent
                    className=" mt-2"
                    placeholder="نوع گروه"
                    options={typeList?.map((item) => ({
                      value: item.id,
                      label: item.title,
                    }))}
                    name="promoCategoryType"
                    field={field}
                  />
                )}
                noClear
              />
              {errors.promoCategoryType && <span className="text-danger">** لطفا نوع گروه را وارد نمایید</span>}

              <FormControlLabel
                control={
                  <Controller
                    control={control}
                    name={"isActive"}
                    render={({ field: { onChange, value, ref } }) => (
                      <Checkbox color="primary" onChange={onChange} checked={value || false} inputRef={ref} />
                    )}
                  />
                }
                label="فعال"
              />

            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {(isSubmitting || loading) && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
